import { processTankData, addGroupSection, addTopMatureSumFormulas } from './tankDataUtils';

export const generateTopMatureSheet = async (ws, lastOps, tankDataMap, volumeUnit, extraOperationFields, t, cellarsRef, tankMapping) => {

  const boldStyle = { 
    font: { bold: true, name: 'Arial' }
  };
  
  const boldCenteredStyle = { 
    font: { bold: true, name: 'Arial' },
    alignment: { horizontal: 'center', vertical: 'middle' },
  };

  // Define constants for row indexing
  const HEADER_ROWS = 4;
  const TANK_DATA_START_ROW = HEADER_ROWS + 1;

  // Set column widths
  ws.columns = Array(18).fill({ width: 25 });

  // Add header rows
  ws.mergeCells('D1:E1');
  ws.getCell('D1').value = 'RHUM MATURE TRADITIONNEL';
  ws.getCell('D1').style = boldCenteredStyle;

  ws.mergeCells('D2:E2');
  ws.getCell('D2').value = 'Inventaire au : ' + new Date().toLocaleDateString('fr-FR');
  ws.getCell('D2').style = boldCenteredStyle;

  // Add column headers
  const headers = [
    'Code article As 400',
    'Cuverie AS 400',
    'FOUDRES N°',
    'Ref alcool',
    'GRADUATION',
    'VOLUME',
    'Q* (TAV)',
    'T',
    'Q (TAV à 20°C)',
    'VOLUME EFFECTIF (à 20°C)',
    'AGE EN MOIS',
    'VOLUME A.P',
    'DATE EN SERVICE FOUDRES',
  ];

  headers.forEach((header, index) => {
    const cell = ws.getCell(4, index + 1);
    cell.value = header;
    cell.style = boldStyle;
  });
  
  // Group tanks by groupName
  const sortedTankGroups = tankMapping.reduce((groups, mapping) => {
    const groupName = mapping.groupName;
    if (!groups.find(g => g.groupName === groupName)) {
      groups.push({
        groupName,
        tanks: []
      });
    }
    const group = groups.find(g => g.groupName === groupName);
    group.tanks.push({
      tankName: mapping.tankName,
      cuverieAS400: mapping.cuverieAS400,
      codeArticleAS400: mapping.codeArticleAS400,
      refAlcohol: mapping.refAlcohol,
      serviceDate: mapping.serviceDate
    });
    return groups;
  }, []);

  // Process the manually sorted tanks into separate arrays per group
  const tankDataByGroup = sortedTankGroups.map(group => {
    return group.tanks.map(tank => {
      const tankId = Object.keys(tankDataMap).find(id => 
        String(tankDataMap[id].name) === String(tank.tankName)
      );
      if (tankId && tankDataMap[tankId]) {
        return {
          tankId,
          ...tankDataMap[tankId],
          cuverieAS400: tank.cuverieAS400,
          codeArticleAS400: tank.codeArticleAS400,
          serviceDate: tank.serviceDate,
          refAlcohol: tank.refAlcohol
        };
      } else {
        // Return a minimal tank object for tanks that don't have data
        return {
          tankId: null,
          name: tank.tankName,
          cuverieAS400: tank.cuverieAS400,
          codeArticleAS400: tank.codeArticleAS400,
          serviceDate: tank.serviceDate,
          refAlcohol: tank.refAlcohol,
          fullActiveCert: { capacity: 0 }
        };
      }
    });
  });

  // Process and add each group
  const processGroup = async (groupIndex, groupTitle, startRow) => {
    const groupDataPromises = tankDataByGroup[groupIndex].map((tankData, index) => 
      processTankData(tankData, index, lastOps, tankDataMap, volumeUnit, startRow + 3, cellarsRef)
    );
    const groupData = await Promise.all(groupDataPromises);
    
    // Add group section
    const dataStartRow = addGroupSection(ws, groupTitle, startRow, boldCenteredStyle) + 1;
    
    // Add tank data
    groupData.forEach((tank, index) => {
      tank.row.forEach((value, colIndex) => {
        const cell = ws.getCell(dataStartRow + index, colIndex + 1);
        if (typeof value === 'object' && value !== null) {
          if (value.t === 's') {
            cell.value = value.v;
          } else if (value.t === 'n' && value.f) {
            cell.value = { formula: value.f };
          }
        } else {
          cell.value = value;
        }
      });
    });
    
    // Add sum formulas
    const lastDataRow = dataStartRow + groupData.length - 1;
    const sumRow = lastDataRow + 1;
    addTopMatureSumFormulas(ws, dataStartRow, lastDataRow, sumRow, boldStyle);
    
    return sumRow + 1; // Return next start row
  };

  // Process all groups in sequence
  let currentRow = TANK_DATA_START_ROW;
  
  // Process RHUM MATURE TRADITIONNEL (group 0)
  const rhumTradiDataPromises = tankDataByGroup[0].map((tankData, index) => 
    processTankData(tankData, index, lastOps, tankDataMap, volumeUnit, currentRow, cellarsRef)
  );
  const rhumTradiData = await Promise.all(rhumTradiDataPromises);
  
  rhumTradiData.forEach((tank, index) => {
    tank.row.forEach((value, colIndex) => {
      const cell = ws.getCell(currentRow + index, colIndex + 1);
      if (typeof value === 'object' && value !== null) {
        if (value.t === 's') {
          cell.value = value.v;
        } else if (value.t === 'n' && value.f) {
          cell.value = { formula: value.f };
        }
      } else {
        cell.value = value;
      }
    });
  });
  
  const lastRhumTradiRow = currentRow + rhumTradiData.length - 1;
  const rhumTradiSumRow = lastRhumTradiRow + 1;
  addTopMatureSumFormulas(ws, currentRow, lastRhumTradiRow, rhumTradiSumRow, boldStyle);
  
  currentRow = rhumTradiSumRow + 1;

  // Process remaining groups
  const groupTitles = [
    'AGRICOL BLANC et MATURE',
    'CUVE DE MÉLANGE TRAD MATURE ET BLANC',
    'CUVE EXTERIEUR RHUM TRAD',
    'CUVE EXTERIEUR RHUM LEGER ALCOOL CANNE'
  ];

  for (let i = 0; i < groupTitles.length; i++) {
    currentRow = await processGroup(i + 1, groupTitles[i], currentRow);
  }
};
